module.exports = __webpack_public_path__ + "img/Logo-14.32e84228.svg";